import { render, staticRenderFns } from "./ArticlesCategorie.vue?vue&type=template&id=172896d8&scoped=true&"
import script from "./ArticlesCategorie.vue?vue&type=script&lang=js&"
export * from "./ArticlesCategorie.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesCategorie.vue?vue&type=style&index=0&id=172896d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172896d8",
  null
  
)

export default component.exports